import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { Market, MarketPump } from "../types/Market";
import { RootState } from "../store";

interface PumpState {
  markets: Market[];
  pumps: MarketPump[];
  percentPumps: MarketPump[];
  krwRate: number;
  minVolume: number;
  bybitMarkets: string[];
  latestUpdate: number;
  connected: boolean;
}

const initialState: PumpState = {
  markets: [],
  pumps: [],
  percentPumps: [],
  krwRate: 1295.5161,
  minVolume: 20000,
  bybitMarkets: [],
  latestUpdate: new Date().valueOf(),
  connected: false,
};

const pumpSlice = createSlice({
  name: "pumps",
  initialState,
  reducers: {
    requestPumpConnect(state) {
      // Handled by middleware
    },
    setPumpConnected(state, action: PayloadAction<boolean>) {
      state.connected = action.payload;
    },
    setMarkets(state, action: PayloadAction<Market[]>) {
      state.markets = action.payload;
    },
    setBybitMarkets(state, action: PayloadAction<string[]>) {
      state.bybitMarkets = action.payload;
    },
    updatePumps(state, action: PayloadAction<MarketPump[]>) {
      state.pumps = action.payload;
      state.latestUpdate = new Date().valueOf();
    },
    updatePercentPumps(state, action: PayloadAction<MarketPump[]>) {
      state.percentPumps = action.payload;
    },
    setKrwRate(state, action: PayloadAction<number>) {
      state.krwRate = action.payload;
    },
    setMinVolume(state, action: PayloadAction<number>) {
      state.minVolume = action.payload;
    },
    resetPumps(state) {
      state.pumps = state.pumps.map((r) => ({
        ...r,
        reference_price: r.latest_price,
        reference_timestamp: r.latest_timestamp,
        volume: 0,
      }));
      // Recompute percentPumps after reset
      state.percentPumps = [];
    },
  },
});

export const {
  requestPumpConnect,
  setPumpConnected,
  setMarkets,
  setBybitMarkets,
  updatePumps,
  updatePercentPumps,
  setKrwRate,
  setMinVolume,
  resetPumps,
} = pumpSlice.actions;

export const selectPumps = (state: RootState) => state.pumps.pumps;
export const selectPercentPumps = (state: RootState) => state.pumps.percentPumps;
export const selectMarkets = (state: RootState) => state.pumps.markets;
export const selectBybitMarkets = (state: RootState) => state.pumps.bybitMarkets;
export const selectKrwRate = (state: RootState) => state.pumps.krwRate;
export const selectMinVolume = (state: RootState) => state.pumps.minVolume;
export const selectLatestUpdate = (state: RootState) => state.pumps.latestUpdate;
export const selectPumpConnected = (state: RootState) => state.pumps.connected;

export default pumpSlice.reducer;
